import { render, staticRenderFns } from "./Policy.vue?vue&type=template&id=ec36ad6e&scoped=true"
var script = {}
import style0 from "./Policy.vue?vue&type=style&index=0&id=ec36ad6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec36ad6e",
  null
  
)

export default component.exports